// extracted by mini-css-extract-plugin
export var header = "_wr-1";
export var maskBottom = "_wr-6";
export var maskMiddle = "_wr-7";
export var maskTop = "_wr-5";
export var root = "_wr-0";
export var scrollDownButton = "_wr-3";
export var scrollDownButtonHidden = "_wr-4";
export var viewport = "_wr-2";